/*  ==========================================================================
    EHOTELIER LOADER
    Helper to load data from ehotelier easy and fast.

    Info:
    - works with "handlebars loader" and "webpack"
    - Simple usage example:
        import * as utils from '../../utilities/utils';
        function funcHook(container,data) {
        }
        function funcCustom(container) {
        }
        let config = {
            container: '.container',
            funcCustom: funcCustom,
            funcHook: funcHook,
            type: 'offer',
            subtype: 'list-view'
        };
        utils.ehotelierLoader.initEhotlierService(config);
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';

// local imports
import * as vars from '../../globals/variables';

// hbs imports
import hbs_additionalListView from '../../../hbs/ehotelier/additional/list-view.hbs';
import hbs_freeRoomListView from '../../../hbs/ehotelier/freeroom/list-view.hbs';
import hbs_offerDetail from '../../../hbs/ehotelier/offer/detail.hbs';
import hbs_offerListView from '../../../hbs/ehotelier/offer/list-view.hbs';
import hbs_offerListViewV2 from '../../../hbs/ehotelier/offer/list-view-v2.hbs';
import hbs_offerPopUp from '../../../hbs/ehotelier/offer/pop-up.hbs';
import hbs_offerTeaser from '../../../hbs/ehotelier/offer/teaser.hbs';
import hbs_roomDetail from '../../../hbs/ehotelier/room/detail.hbs';
import hbs_roomListView from '../../../hbs/ehotelier/room/list-view.hbs';
import hbs_roomListViewV2 from '../../../hbs/ehotelier/room/list-view-v2.hbs';
import hbs_roomListViewV3 from '../../../hbs/ehotelier/room/list-view-v3.hbs';
import hbs_roomPopUp from '../../../hbs/ehotelier/room/pop-up.hbs';
import hbs_roomPriceOverview from '../../../hbs/ehotelier/room/price-overview.hbs';
import hbs_weatherDetail from '../../../hbs/ehotelier/weather/detail.hbs';
import hbs_weatherTeaser from '../../../hbs/ehotelier/weather/teaser.hbs';
import hbs_weatherTeaserV2 from '../../../hbs/ehotelier/weather/teaser-v2.hbs';

/*
 * EHOTELIER LOADER
 */

// for testing purposes, new hotel id gets added to the freeroom service (only when "001_BRANDNAMIC_1" id is given, because the brandnamic hotel has no freeroom service!)
let eh_hid_freeroom = vars.eh_hid;
if (eh_hid_freeroom === '001_BRANDNAMIC_1') {
    eh_hid_freeroom = '001_LANERHOF_621';
}

// service datas
let data = [];
data['additional'] = {
    'fields': JSON.stringify({
        '*': null,
        'additionalcategories': {
            '*': null
        },
        'galleryimages': {
            '*': null
        }
    }),
    'hotel_ids': vars.eh_hid,
    'portal_id': vars.eh_pid
};
data['freeroom'] = {
    'amounts': null,
    'fields': JSON.stringify({
        '*': null,
        'hotel': {
            '*': null
        },
        'roomtype': {
            '*': null,
            'roomtypeboards': {
                '*': null,
                'board': {
                    '*': null
                }
            }
        }
    }),
    'getoffers': false,
    'getrestplaetze': true,
    'getrooms': true,
    'getroomswithoutpricestoo': true,
    'nightsmax': 7,
    'portal_id': vars.eh_pid,
    'hotel_ids': eh_hid_freeroom,
    'restplatzamount': true,
    'sort': 'fromdate:asc'
};
data['offer'] = {
    'hotel_ids': vars.eh_hid,
    'portal_id': vars.eh_pid,
    'fields': JSON.stringify({
        '*': null,
        'offercategories': {
            'id': null,
            'title': null
        },
        'offerhotels': {
            '*': null,
            'roomprices': {
                '*': null,
                'roomtype': {
                    '*': null
                },
                'roompriceguests': {
                    '*': null
                },
                'board': {
                    '*': null
                }
            }
        },
        'seasondatas': {
            '*': null
        }
    }),
    'getexpired': 'false',
    'showhiddencategories': false,
    'sort': 'fromdate:asc'
};
data['room'] = {
    'fields': JSON.stringify({
        '*': null,
        'roomtypes': {
            'name': null,
            'id': null,
            'category': null,
            'defaultpersons': null,
            'minpersons': null,
            'maxpersons': null,
            'description': null,
            'asacode': null,
            'externalid': null,
            'sizeinqm': null,
            'size_measurement': null,
            'subtitle': null,
            'image1': null,
            'image1copyright': null,
            'image2': null,
            'image2copyright': null,
            'image3': null,
            'image3copyright': null,
            'image4': null,
            'image4copyright': null,
            'galleryimages' :{
                '*': null
            },
            'information': null,
            'roomprices': {
                'roompriceguests': {
                    '*': null
                },
                'minstay': null,
                'maxstay': null,
                'board': {
                    '*': null
                },
                'seasondatas': {
                    'season': {
                        '*': null
                    },
                    'fromdate': null,
                    'todate': null
                }
            },
            'roomtypeboards': {
                '*': null,
                'board' :{
                    '*': null
                }
            },
            'roomtypefeatures': {
              '*': null
            },
            'url': null
        },
        'seasons': {
            'name': null,
            'description': null,
            'seasondatas': {
                'season': {
                    '*': null
                },
                'fromdate': null,
                'todate': null
            }
        }
    }),
    'hotel_ids': vars.eh_hid,
    'portal_id': vars.eh_pid
};
data['textplugin'] = {
    'hotel_id': vars.eh_hid,
    'portal_id': vars.eh_pid
};
data['weather'] = {
    'fields': [
        'today',
        'tomorrow',
        'mountaintoday',
        'mountaintomorrow',
        'evolutiontitle',
        'evolution',
        'dayforecast0',
        'dayforecast1',
        'dayforecast2',
        'dayforecast3'
    ].join()
};

// service paths
let path = [];
path['additional'] = 'services/additional/'+vars.lang;
path['freeroom'] = 'services/freeroomsservice/'+vars.lang;
path['offer'] = 'services/offer/'+vars.lang;
path['room'] = 'services/hoteldata/'+vars.lang;
path['textplugin'] = 'services/textplugin/'+vars.lang+'/1';
path['weather'] = vars.lang+'/weatherdata';

// templates
let template = {
    'additional': {
        'list-view': hbs_additionalListView
    },
    'freeroom': {
        'list-view': hbs_freeRoomListView
    },
    'offer': {
        'detail': hbs_offerDetail,
        'list-view': hbs_offerListView,
        'list-view-v2': hbs_offerListViewV2,
        'pop-up': hbs_offerPopUp,
        'teaser': hbs_offerTeaser
    },
    'room': {
        'detail': hbs_roomDetail,
        'list-view': hbs_roomListView,
        'list-view-v2': hbs_roomListViewV2,
        'list-view-v3': hbs_roomListViewV3,
        'pop-up': hbs_roomPopUp,
        'price-overview': hbs_roomPriceOverview
    },
    'weather': {
        'detail': hbs_weatherDetail,
        'teaser': hbs_weatherTeaser,
        'teaser-v2': hbs_weatherTeaserV2
    }
};

// initialization
export function initEhotlierService(config) {
    let addParams =  config.addParams || '',
        addParamsProcessed = '',
        container = config.container,
        dataType = 'json',
        funcCustom =  config.funcCustom,
        funcHook =  config.funcHook,
        subtype = config.subtype,
        type =  config.type,
        $loader = container.find('.bn-loader'),
        $noResult = container.find('.bn-no-result');

    // change data type for text plugin
    if(type == 'textplugin') {
        dataType = 'html';
    }

    // process additional parameters
    if(addParams !== '') {
        for (let param in addParams) {
            addParamsProcessed = addParamsProcessed + '&' + param + '=' + addParams[param];
        }
    }

    // check if container, type and subtype exist
    if(container && type && subtype) {

        // ajax call to get data
        $.ajax({
            cache: true,
            data: data[type],
            dataType: dataType,
            url: 'https://admin.ehotelier.it/bnlocalproxy.php?path='+path[type]+'&cacheBuster='+vars.cacheBuster+addParamsProcessed
        }).done(function(data) {

            // resort last minute (to get total)
            if(type == 'freeroom') {
                data.total = data.length;
            }

            // resort data weather (to get total)
            if(type == 'weather') {
                data.total = data.data.length;
            }

            // check if data exists
            if(data['total']>0) {

                // add type and subtype info to data
                data.type = type;
                data.subtype = subtype;

                // get ts constants (so you can use it in you hbs template)
                data.trans = vars.ts;

                // hook function (f.e. room prices)
                if(funcHook !== undefined) {
                    funcHook(container, data);
                }

                // remove loader and no result info
                $loader.remove();
                $noResult.remove();

                // data log (only if user is logged in typo3)
                if(vars.$body.hasClass('be-user')) {
                    console.log('');
                    console.log('----------------------------------------------------------------------------------------------------');
                    console.log(type.toUpperCase() + '-' + subtype.toUpperCase() + ':');
                    console.log(data);
                    console.log('----------------------------------------------------------------------------------------------------');
                    console.log('');
                }

                // append object to container
                container.append(template[type][subtype](data));

                // add "ready" class to container
                container.addClass('eh-service--ready');

                // custom function (which will be called after object is inserted)
                if(funcCustom !== undefined) {
                    funcCustom(container, data);
                }

            } else if(type == 'textplugin') {

                // remove loader and no result info
                $loader.remove();
                $noResult.remove();

                // insert data
                container.html(data);

                // add "ready" class to container
                container.addClass('eh-service--ready');

            } else {

                // show no result info and remove loader
                $loader.remove();
                $noResult.removeClass('hidden');

            }
        });

    } else {

        // show no result info and remove loader
        $loader.remove();
        $noResult.removeClass('hidden');

    }

}



// WEBPACK FOOTER //
// ./source/js/utilities/lib/ehotelier-loader.js